@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

/* stylelint-disable */
:export {
  colorpass: $color-secondary-green;
  colorfail: $color-primary-red-hover;
  colorcancelled: $color-grey-C;
  colorerror: $color-warning-orange;
}

/* stylelint-enable */

.ChartWrapper {
  width: 100%;
  height: 160px;
  position: relative;
}
